import { DrawerBase } from 'bog-arcade-core-ui/core/DrawerBase';
import { gameAnimations } from '../../../services/helperServices/GameAnimationService';
import { resourceHelper } from '../../../core/resourceHelper';

export class BaseControlDrawer extends DrawerBase {
  getIcon(
    {
      name,
      onClick,
      activeIconName,
      circleName,
      sizes: { w = 48, h = 48 } = {},
      position: { x = 0, y = 0 } = {},
      observer,
      scale = 1,
    },
  ) {
    const icon = this.createSprite(resourceHelper.get(name));
    const activeIcon = this.createSprite(resourceHelper.get(activeIconName));
    let circle;
    if (circleName) {
      circle = this.createSprite(resourceHelper.get(circleName));
    }

    icon.anchor.set(.5);
    icon.scale.set(scale);
    activeIcon.anchor.set(.5);
    activeIcon.scale.set(scale);
    this.setPosition(activeIcon, { x: w / 2, y: h / 2 });
    this.setPosition(icon, { x: w / 2, y: h / 2 });

    this.addSubscriber(observer.subscribe(state => {
      if (state) {
        activeIcon.visible = true;
        icon.visible = false;
      } else {
        activeIcon.visible = false;
        icon.visible = true;
      }
    }, true));

    const rect = this.createGraphics()
      .drawRect(
        x,
        y,
        w,
        h,
      )
      .endFill();
    this.setupButtonMode(rect);
    this.registerClick(rect, (event) => {
      event.stopPropagation();
      gameAnimations.click(icon, .1, [.9 * scale, scale]);
      gameAnimations.click(activeIcon, .1, [.9 * scale, scale]);
      const state = !observer.getValue();
      observer.next(state);
      onClick({ event, target: rect, state });
    });

    if (circle) {
      circle.anchor.set(.5);
      circle.scale.set(scale * 2);
      this.setPosition(circle, { x: w / 2, y: h / 2 });
      rect.addChild(circle);
    }
    rect.addChild(
      icon,
      activeIcon,
    );
    return rect;
  }
}
